import { render, staticRenderFns } from "./CustomerIngredients.vue?vue&type=template&id=4d155958"
import script from "./CustomerIngredients.vue?vue&type=script&lang=ts"
export * from "./CustomerIngredients.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports